import React, { useState } from "react";
import { DrawerProps } from "antd/lib/drawer";
import { Row, Col } from "antd";
import {
	Product,
	BundleProduct,
	ProductType
} from "@/Contracts/Products";

import "../ProductsDrawer.less";
import SearchDocumentProductCatalog from "@/Components/DocumentsPage/Drawers/DocumentProductDrawers/SearchDocumentProductCatalogDrawer/SearchDocumentProductCatalog";
import ConfigureBundleChildProductDrawer from "../ConfigureBundleChildProductDrawer";
import { Document } from "@/Contracts/Documents";
import ZMessage from "@molecules/ZMessage";
import ZDrawer from "@molecules/ZDrawer";

interface AddBundleChildToProductDrawerProps extends DrawerProps {
	onSubmit: (product: BundleProduct) => void;
	currentActiveDocument: Document | null;
	readonly isFromProductsPage: boolean;
	readonly bundledProductList: BundleProduct[];
}
export const AddBundleChildToProductDrawer: React.FC<
	AddBundleChildToProductDrawerProps
> = props => {
	const [selectedQuoteProduct, setSelectedQuoteProduct] =
		useState<BundleProduct | null>(null);

	const handleSubmit = (
		selectedProducts: Product[],
		productVsPricing: Record<string, string | null>
	) => {
		try {
			const selectedProduct = selectedProducts[0];
			if (selectedProduct.type === ProductType.Bundle) {
				ZMessage.error("You cannot add a bundle to another bundle");
				return;
			}
			const selectedPricing = selectedProduct.pricing?.find(
				p => p.id === productVsPricing[selectedProduct.id]
			);
			const childProductRequest: BundleProduct = {
				item_id: selectedProduct.id,
				item: selectedProduct,
				quantity: 1,
				selected_pricing_id: selectedPricing?.id,
				selected_setup_price: selectedPricing?.setup_price,
				selected_cost_price: selectedPricing?.cost_price,
				selected_billing_period: selectedPricing?.billing_period,
				is_optional: false,
				is_selected: false,
				sell_price: selectedPricing?.sell_price,
				tax_category_id: selectedProduct.tax_category_id,
				custom_fields: selectedProduct.custom_fields,
				mandatory_custom_field_check_require: true
			};
			setSelectedQuoteProduct(childProductRequest);
		} catch (error) {
			console.error(error);
		}
	};

	const handleConfigureDrawerClose = () => setSelectedQuoteProduct(null);

	const handleConfigureProductSubmit = async (
		quoteProduct: BundleProduct
	) => {
		setSelectedQuoteProduct(null);
		if (props.onClose) {
			props.onClose({} as any);
		}
		props.onSubmit(quoteProduct);
	};

	const isConfigureDrawerVisible = !!selectedQuoteProduct;

	return (
		<ZDrawer
			visible={props.visible}
			closable={true}
			destroyOnClose={true}
			onClose={props.onClose}
			className="document-product-drawer search-document-product-drawer zomentum-drawer"
			title={
				<Row>
					<Col span={24}>
						<div className="drawer-title-container">
							<div className="drawer-title">Search Product</div>
						</div>
					</Col>
				</Row>
			}
		>
			<SearchDocumentProductCatalog
				isLoading={false}
				onClose={props.onClose}
				onSubmit={handleSubmit}
				itemType={"bundle"}
				isFromProductsPage={props.isFromProductsPage}
			/>

			<ConfigureBundleChildProductDrawer
				currentActiveProduct={selectedQuoteProduct}
				onClose={handleConfigureDrawerClose}
				onSubmit={handleConfigureProductSubmit}
				visible={isConfigureDrawerVisible}
				currentActiveDocument={props.currentActiveDocument}
				bundledProductList={props.bundledProductList}
			/>
		</ZDrawer>
	);
};
